import { bindActionCreators } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch } from 'react-redux';

import { track as _track } from '../../../actions/tracking';
import { RenderClientSide } from '../../../components/render';
import Articles from './Articles';
import TestDriveArticles from './TestDriveArticles';
import TestDriveLatestArticle from './TestDriveLatestArticle';

const ArticlesSection = () => {
  const dispatch = useDispatch();
  const trackWidthDispatch = bindActionCreators(_track, dispatch);

  const track = (event: string, data: any) => trackWidthDispatch(event, data);

  return (
    <>
      <TestDriveLatestArticle track={track} />
      <RenderClientSide>
        <>
          <TestDriveArticles track={track} />
          <Articles track={track} />
        </>
      </RenderClientSide>
    </>
  );
};

export default ArticlesSection;
